import type { StripeSubscription } from '@flintmint/core-shared/firestore/schemas';
import type { Tier } from '@flintmint/core-shared/utils';
import type { BadgeTone } from '@/components/badge';
import { ENVIRONMENT } from '@/constants';

export const subscriptionStatusLabels: Record<StripeSubscription['status'], string> = {
  active: 'Active',
  trialing: 'Trialing',
  past_due: 'Past due',
  canceled: 'Canceled',
  unpaid: 'Unpaid',
  incomplete: 'Incomplete',
  incomplete_expired: 'Expired',
  paused: 'Paused',
};

export const subscriptionStatusTones: Record<StripeSubscription['status'], BadgeTone> = {
  active: 'green',
  trialing: 'blue',
  past_due: 'amber',
  canceled: 'red',
  unpaid: 'amber',
  incomplete: 'red',
  incomplete_expired: 'grey',
  paused: 'grey',
};

export const tierLabels: Record<Tier, string> = {
  free: 'Free',
  paid: 'Paid',
  comped: 'Comped',
};

export const tierTones: Record<Tier, BadgeTone> = {
  free: 'grey',
  paid: 'green',
  comped: 'teal',
};

export const stripeCustomerUrl = (stripeCustomerId: string): string =>
  ENVIRONMENT.VITE_ENVIRONMENT === 'production'
    ? `https://dashboard.stripe.com/customers/${stripeCustomerId}`
    : `https://dashboard.stripe.com/test/customers/${stripeCustomerId}`;
